// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingFilledSvg from "@fishx/icons-svg/es/asn/ShoppingFilled";
import FishxIcon from '../components/FishxIcon';

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingFilledSvg
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
export default React.forwardRef(ShoppingFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShoppingFilled.js
// module id = 4105
// module chunks = 0